export const grassTypes = [
    {
        value: 0,
        label: "Cool Season (base 0c GDD)"
    },
    {
        value: 1,
        label: "Warm Season (base 10c GDD)"
    }
]